import { render } from "./BuItemRepairDetail.vue?vue&type=template&id=14b0482d&scoped=true"
import script from "./BuItemRepairDetail.vue?vue&type=script&lang=js"
export * from "./BuItemRepairDetail.vue?vue&type=script&lang=js"

import "./BuItemRepairDetail.vue?vue&type=style&index=0&id=14b0482d&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b0482d"]])

export default __exports__